import { useRef, useEffect } from 'react'
import { useDispatch } from 'react-redux'

import { v4 as uuidv4 } from 'uuid'

import {
  setGovernanceMetadata,
  setSelectedGovernance,
} from '../../../../redux/governanceReducer'

import {
  Actions,
  CancelBtn,
  CloseBtn,
  InputBox,
  InputFieldModal,
  LargeModal,
  ModalContentWrapper,
  ModalContent,
  ModalHeader,
  ModalLabel,
  StyledPopup,
  SubmitBtnModal,
} from '../../Styles/CommonStylesForms'

function AddFormGovernanceMetadata(props) {
  const dispatch = useDispatch()

  const error = props.error

  const metadataForm = useRef()
  const submitBtn = useRef()

  const guid = uuidv4()

  useEffect(() => {
    if (error && submitBtn.current) {
      submitBtn.current.removeAttribute('disabled')
    }
  }, [error])

  // Disable button on submit
  const onBtnClick = (e) => {
    if (submitBtn.current) {
      submitBtn.current.setAttribute('disabled', 'disabled')
    }
  }

  const handleSubmit = async (e) => {
    e.preventDefault()
    onBtnClick()

    // (eldersonar) Save as UNIX timestamp
    const timestamp = Math.floor(Date.now() / 1000)

    const form = new FormData(metadataForm.current)

    const metadata = {
      author: form.get('author'),
      id: form.get('id'),
      name: form.get('name'),
      description: form.get('description'),
      format: form.get('format'),
      uri: form.get('uri'),
      docs_uri: form.get('docs_uri'),
      last_updated: timestamp,
      '@context': [
        'https://github.com/hyperledger/aries-rfcs/blob/main/concepts/0430-machine-readable-governance-frameworks/context.jsonld',
      ],
    }

    let governanceTemplate = {}
    governanceTemplate = {
      ...metadata,
      schemas: {},
      participants: {},
      roles: {},
    }

    dispatch(setSelectedGovernance(governanceTemplate))
    dispatch(setGovernanceMetadata(metadata))

    props.closeAddMetadataModal()
  }

  function closeModal() {
    // setOptions([])
    props.closeAddMetadataModal()
  }

  return (
    <StyledPopup
      open={props.addMetadataModalIsOpen}
      closeOnDocumentClick
      onClose={closeModal}
    >
      <LargeModal className="modal">
        <ModalHeader>Add Governance Metadata</ModalHeader>
        <ModalContentWrapper>
          <ModalContent>
            <form id="form" onSubmit={handleSubmit} ref={metadataForm}>
              <InputBox>
                <ModalLabel htmlFor="author">Author</ModalLabel>
                <InputFieldModal
                  type="text"
                  name="author"
                  id="author"
                  placeholder="did:example:sampleecosystemgovernanceparty"
                />
              </InputBox>
              <InputBox>
                <ModalLabel htmlFor="id">Id</ModalLabel>
                <InputFieldModal
                  type="text"
                  name="id"
                  id="id"
                  placeholder="<uuid>"
                  defaultValue={guid}
                />
              </InputBox>
              <InputBox>
                <ModalLabel htmlFor="name">Name</ModalLabel>
                <InputFieldModal
                  type="text"
                  name="name"
                  id="name"
                  placeholder="Country Health Governance"
                />
              </InputBox>
              <InputBox>
                <ModalLabel htmlFor="description">Description</ModalLabel>
                <InputFieldModal
                  type="text"
                  name="description"
                  id="description"
                  placeholder="Selected schemas and trusted participants for the nation of 'country'"
                />
              </InputBox>
              <InputBox>
                <ModalLabel htmlFor="format">Format</ModalLabel>
                <InputFieldModal
                  type="text"
                  name="format"
                  id="format"
                  placeholder="1.0"
                />
              </InputBox>
              <InputBox>
                <ModalLabel htmlFor="uri">URI</ModalLabel>
                <InputFieldModal
                  type="text"
                  name="uri"
                  id="uri"
                  placeholder="https://governance.com/uuid.json"
                />
              </InputBox>
              <InputBox>
                <ModalLabel htmlFor="docs_uri">
                  Human Readable Version URI
                </ModalLabel>
                <InputFieldModal
                  type="text"
                  name="docs_uri"
                  id="docs_uri"
                  placeholder="https://country.gov/health/2022-health-standards/index.html"
                />
              </InputBox>
              <Actions>
                <CancelBtn
                  id="button-cancel"
                  type="button"
                  onClick={closeModal}
                >
                  Cancel
                </CancelBtn>
                <SubmitBtnModal id="button-add" type="submit" ref={submitBtn}>
                  Add
                </SubmitBtnModal>
              </Actions>
            </form>
          </ModalContent>
        </ModalContentWrapper>
        <CloseBtn id="button-exit" onClick={closeModal}>
          &times;
        </CloseBtn>
      </LargeModal>
    </StyledPopup>
  )
}

export default AddFormGovernanceMetadata
